export const TABLE_VIEWS_SAVE_REQUESTED = 'TABLE_VIEWS_SAVE_REQUESTED'
export const TABLE_VIEW_DELETE_REQUESTED = 'TABLE_VIEW_DELETE_REQUESTED'
export const TABLE_VIEW_FETCH_REQUESTED = 'TABLE_VIEW_FETCH_REQUESTED'
export const TABLE_VIEWS_LIST_FETCH_REQUESTED = 'TABLE_VIEWS_LIST_FETCH_REQUESTED'
export const TABLE_VIEWS_LIST_RESET = 'TABLE_VIEWS_LIST_RESET'
